import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Body from "./components/Body";
import { useState } from "react";
import Credits from "./components/Credits";
import HamburgerToggle from "./components/HamburgerToggle";
import Footer from "./components/Footer";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

const AppLayout = () => {
  const [searchResults, setSearchResults] = useState([]);

  return (
    <div className="main-app bg-black">
      <HamburgerToggle />
      <Header onSearch={setSearchResults} />
      <Outlet context={[searchResults]} />
      <Footer />
    </div>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Body />,
      },
      {
        path: "/credits/:movieId",
        element: <Credits />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={appRouter} />);
